type SubmitEvent = {
  preventDefault(): void;
  stopPropagation(): void;
};
type KeyEvent = SubmitEvent & {
  key: string;
  shiftKey: boolean;
  metaKey: boolean;
  ctrlKey: boolean;
};

/** Block before submission can clear attachments or change the follow-up mode.
 * Plain Shift+Enter remains available for adding a line to the draft. */
export function blockComposerSubmit(event: SubmitEvent | KeyEvent, active: boolean): boolean {
  if (!active) return false;
  if (
    'key' in event &&
    (event.key !== 'Enter' || (event.shiftKey && !event.metaKey && !event.ctrlKey))
  )
    return false;
  event.preventDefault();
  event.stopPropagation();
  return true;
}
